module.exports = __webpack_public_path__ + "static/media/gp.b1feb2ba.svg";